import React, { FC } from 'react';

import { cn } from '@/shared/lib/tailwind-merge';

interface LoaderProps {
    size?: 'small' | 'default' | 'large';
    className?: string;
}

const sizeClasses = {
    small: 'h-4 w-4 border-2',
    default: 'h-6 w-6 border-2',
    large: 'h-8 w-8 border-4',
};

export const Loader: FC<LoaderProps> = ({ size = 'default', className }) => {
    return (
        <div
            className={cn(
                'inline-block rounded-full border-t-2 border-l-2 border-dashed border-gray-300',
                sizeClasses[size],
                className,
            )}
        />
    );
};
